import { render } from "./OrderDetailsShipping.vue?vue&type=template&id=8c5784e0"
import script from "./OrderDetailsShipping.vue?vue&type=script&lang=js"
export * from "./OrderDetailsShipping.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__